import React from 'react';
import { Heart, User } from 'tabler-icons-react';
import {
  Card,
  Image,
  Text,
  Group,
  Badge,
  Button,
  ActionIcon,
  createStyles,
  useMantineTheme,
  PasswordInput,
  TextInput,
  Title
} from '@mantine/core';
import error_image from '../assets/error_image.jpg'





const useStyles = createStyles((theme) => ({
    card: {
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.white,
        margin: '0 auto',
        width: "80%"
    },
    cardInput: {
        width: "80%"
    },
    titleText: {
        textAlign: "center"
    },
    forgotPw: {
        color: "blue",
        margin: "0 auto",
        textAlign: "center"
    },
    forgotPwContain: {
        textAlign: "center",
        width: "75%",
        margin: "0 auto"
    },
    inputFields: {
        width: '80%',
        margin: '0 auto'
    }
}));


export function ErrorCard() {
    const { classes } = useStyles();
    const theme = useMantineTheme();
    const sendMeHome = () => {
        //add logic to better navigate 
        window.location.href = "https://app.ready.auction/auth/login"
    }


    return (
        <Card shadow="sm" padding="lg" radius="md" withBorder className={classes.card}>
            <Card.Section>
                <Image src={error_image} alt="Ready Auction Error" mx="auto" width={300} height={300}  withPlaceHolder/>
            </Card.Section>
            <br/>
            <Card.Section>
                <Title className={classes.titleText} inline={true}>WHOOPS! We Ran Into Issues Trying To Find That!</Title>
            </Card.Section>
            <br/>
            <br/>
            <Button leftIcon={<User />} fullWidth={true} onClick={sendMeHome}>
                Send Me Home
            </Button>
            <br/>
            <br/>
            <br/>
        </Card>
    );
}
